import { Task } from '@/lib/types';
import { formatDate } from '@/lib/utils/timezone';
import { StatusBadge } from '../status-badge';
import { PriorityBadge } from '../priority-badge';
import { CategoryBadge } from '../category-badge';

interface TaskDetailsViewProps {
  task: Task;
}

export function TaskDetailsView({ task }: TaskDetailsViewProps) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Title</h3>
        <p className="mt-1 text-lg">{task.title}</p>
      </div>

      <div>
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Description</h3>
        <p className="mt-1">{task.description || 'No description provided'}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Status</h3>
          <div className="mt-1">
            <StatusBadge status={task.status} />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Priority</h3>
          <div className="mt-1">
            <PriorityBadge priority={task.priority} />
          </div>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Category</h3>
          <div className="mt-1">
            <CategoryBadge category={task.category} />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Date Assigned</h3>
          <p className="mt-1">
            {task.date_assigned ? formatDate(task.date_assigned) : 'Not set'}
          </p>
        </div>

        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Due Date</h3>
          <p className="mt-1">
            {task.due_date ? formatDate(task.due_date) : 'No due date'}
          </p>
        </div>
      </div>

      <div>
        <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Owner</h3>
        <p className="mt-1">
          {task.owner ? (
            <span>
              {task.owner.name}
              {task.owner.organization && ` (${task.owner.organization})`}
            </span>
          ) : (
            'No owner assigned'
          )}
        </p>
      </div>

      {task.notes && (
        <div>
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400">Notes</h3>
          <p className="mt-1 whitespace-pre-wrap">{task.notes}</p>
        </div>
      )}
    </div>
  );
}